import { render, staticRenderFns } from "./ImportAlumniEducation.vue?vue&type=template&id=2c24c214&"
import script from "./ImportAlumniEducation.vue?vue&type=script&lang=js&"
export * from "./ImportAlumniEducation.vue?vue&type=script&lang=js&"
import style0 from "./ImportAlumniEducation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports